/**
 *  페이지 이름
 *  @readonly
 *  @type {{CATEGORY_CREATE_MANAGEMENT: string, CATEGORY_EXHIBIT_MANAGEMENT: string}}
 */
export const CATEGORY_PAGE_NAME = {
  CATEGORY_CREATE_MANAGEMENT: '카테고리 생성 관리',
  CATEGORY_EXHIBIT_MANAGEMENT: '카테고리 전시 관리',
};

/**
 * 카테고리 선택 초기 타입
 * @readonly
 * @type {{INIT: number}}
 */
export const CATEGORY_SELECT_INITIAL_TYPE = {
  INIT: 0,
};

/**
 * 카테고리 선택 초기 타입 텍스트
 * @readonly
 * @type {{[p: string]: string, [p: number]: string}}
 */
export const CATEGORY_SELECT_INITIAL_TYPE_TEXT = {
  [CATEGORY_SELECT_INITIAL_TYPE.INIT]: '선택',
};

/**
 * 카테고리 선택 초기 타입 SELECT LIST
 * @readonly
 * @type {[{name: string, id: number}]}
 */
export const CATEGORY_SELECT_INITIAL_TYPE_SELECT_LIST = [
  {
    id: CATEGORY_SELECT_INITIAL_TYPE.INIT,
    name: CATEGORY_SELECT_INITIAL_TYPE_TEXT[CATEGORY_SELECT_INITIAL_TYPE.INIT],
  },
];

/**
 *  카테고리 타입
 */
export const CATEGORY_TYPE = {
  /**
   *  일반형
   */
  GENERAL: 0,
  /**
   *  강조형
   */
  EMPHASIS: 1,
} as const;

/**
 * 카테고리 타입 텍스트
 * @readonly
 * @type {{[p: string]: string, [p: number]: string}}
 */
export const CATEGORY_TYPE_TEXT = {
  [CATEGORY_TYPE.GENERAL]: '일반형',
  [CATEGORY_TYPE.EMPHASIS]: '강조형',
};

/**
 *  카테고리 타입 SELECT LIST
 * @readonly
 * @type {[{name: string, id: number}, {name: string, id: number}]}
 */
export const CATEGORY_TYPE_SELECT_LIST = [
  {
    id: CATEGORY_TYPE.GENERAL,
    name: CATEGORY_TYPE_TEXT[CATEGORY_TYPE.GENERAL],
  },
  {
    id: CATEGORY_TYPE.EMPHASIS,
    name: CATEGORY_TYPE_TEXT[CATEGORY_TYPE.EMPHASIS],
  },
];

/**
 * 카테고리정렬순 타입
 */
export const CATEGORY_SORT_TYPE = {
  /**
   *  트렌드순
   */
  TREND: 0,
  /**
   *  인기순
   */
  POPULAR: 1,
  /**
   *  신상품순
   */
  NEW: 2,
  /**
   *  낮은가격순
   */
  MIN_PRICE: 3,
  /**
   *  높은가격순
   */
  MAX_PRICE: 4,
} as const;

/**
 * 카테고리정렬순 타입 텍스트
 * @readonly
 * @type {{[p: string]: string, [p: number]: string}}
 */
export const CATEGORY_SORT_TYPE_TEXT = {
  /**
   *  트렌드순
   */
  [CATEGORY_SORT_TYPE.TREND]: '트렌드순',
  /**
   *  인기순
   */
  [CATEGORY_SORT_TYPE.POPULAR]: '인기순',
  /**
   *  신상품순
   */
  [CATEGORY_SORT_TYPE.NEW]: '신상품순',
  /**
   *  낮은가격순
   */
  [CATEGORY_SORT_TYPE.MIN_PRICE]: '낮은가격순',
  /**
   *  높은가격순
   */
  [CATEGORY_SORT_TYPE.MAX_PRICE]: '높은가격순',
};

/**
 * 강조형 카테고리 이미지 타입
 */
export const CATEGORY_ATTACHMENTS_IMAGE_TYPE = {
  NORMAL: 0,
} as const;

/**
 * 카테고리정렬순 타입 SELECT LIST
 * @readonly
 * @type {[{name: string, id: number}, {name: string, id: number}, {name: string, id: number}, {name: string, id: number}, {name: string, id: number}]}
 */
export const CATEGORY_SORT_TYPE_SELECT_LIST = [
  {
    id: CATEGORY_SORT_TYPE.TREND,
    name: CATEGORY_SORT_TYPE_TEXT[CATEGORY_SORT_TYPE.TREND],
  },
  {
    id: CATEGORY_SORT_TYPE.POPULAR,
    name: CATEGORY_SORT_TYPE_TEXT[CATEGORY_SORT_TYPE.POPULAR],
  },
  {
    id: CATEGORY_SORT_TYPE.NEW,
    name: CATEGORY_SORT_TYPE_TEXT[CATEGORY_SORT_TYPE.NEW],
  },
  {
    id: CATEGORY_SORT_TYPE.MIN_PRICE,
    name: CATEGORY_SORT_TYPE_TEXT[CATEGORY_SORT_TYPE.MIN_PRICE],
  },
  {
    id: CATEGORY_SORT_TYPE.MAX_PRICE,
    name: CATEGORY_SORT_TYPE_TEXT[CATEGORY_SORT_TYPE.MAX_PRICE],
  },
];

/**
 * 서브텍스트 최대 글자 수
 * @readonly
 * @type {number}
 */
export const MAXIMUM_NUMBER_OF_CATEGORY_SUB_TEXT = 20;

/**
 * 카테고리 노출 위치 타입
 */
export const CATEGORY_EXPOSE_LOCATION_TYPE = {
  /**
   *  공통
   */
  COMMON: 0,
  /**
   *  로컬
   *  -> 로컬은 카테고리탭에서만 노출됩니다
   */
  LOCAL: 1,
} as const;

/**
 * 카테고리 노출 위치 타입 텍스트
 * @readonly
 * @type {{[p: string]: string, [p: number]: string}}
 */
export const CATEGORY_EXPOSE_LOCATION_TYPE_TEXT = {
  /**
   *  공통
   */
  [CATEGORY_EXPOSE_LOCATION_TYPE.COMMON]: '공통',
  /**
   *  로컬
   *  -> 로컬은 카테고리탭에서만 노출됩니다
   */
  [CATEGORY_EXPOSE_LOCATION_TYPE.LOCAL]: '로컬',
};

/**
 * 카테고리 노출 위치 타입 SELECT LIST
 * @readonly
 * @type {[{name: string, id: number}, {name: string, id: number}]}
 */
export const CATEGORY_EXPOSE_LOCATION_TYPE_SELECT_LIST = [
  {
    id: CATEGORY_EXPOSE_LOCATION_TYPE.COMMON,
    name: CATEGORY_EXPOSE_LOCATION_TYPE_TEXT[CATEGORY_EXPOSE_LOCATION_TYPE.COMMON],
  },
  {
    id: CATEGORY_EXPOSE_LOCATION_TYPE.LOCAL,
    name: CATEGORY_EXPOSE_LOCATION_TYPE_TEXT[CATEGORY_EXPOSE_LOCATION_TYPE.LOCAL],
  },
];

/**
 * 상품 카테고리 종류 타입
 * @readonly
 * @type {{SUB: number, MAIN: number}}
 */
export const PRODUCT_CATEGORY_KIND_TYPE = {
  /**
   *  상품 1차 카테고리
   */
  MAIN: 0,
  /**
   *  상품 2차 카테고리
   */
  SUB: 1,
};

/**
 * 카테고리 상태 타입
 */
export const CATEGORY_STATUS_TYPE = {
  /**
   * 비활성
   */
  INACTIVE: 0,
  /**
   * 활성
   */
  ACTIVE: 1,
} as const;

/**
 * 카테고리 상태 타입 텍스트
 * @readonly
 * @type {{[p: string]: string, [p: number]: string}}
 */
export const CATEGORY_STATUS_TYPE_TEXT = {
  [CATEGORY_STATUS_TYPE.INACTIVE]: '비활성',
  [CATEGORY_STATUS_TYPE.ACTIVE]: '활성',
};

/**
 * 카테고리 상태 타입 SELECT LIST
 * @readonly
 * @type {[{name: string, id: number}, {name: string, id: number}]}
 */
export const CATEGORY_STATUS_TYPE_SELECT_LIST = [
  {
    id: CATEGORY_STATUS_TYPE.ACTIVE,
    name: CATEGORY_STATUS_TYPE_TEXT[CATEGORY_STATUS_TYPE.ACTIVE],
  },
  {
    id: CATEGORY_STATUS_TYPE.INACTIVE,
    name: CATEGORY_STATUS_TYPE_TEXT[CATEGORY_STATUS_TYPE.INACTIVE],
  },
];

/**
 * 카테고리 전시 타입
 */
export const CATEGORY_EXHIBIT_TYPE = {
  /**
   * 미전시
   */
  INEXHIBIT: 0,
  /**
   * 전시
   */
  EXHIBIT: 1,
} as const;

/**
 * 카테고리 전시 타입 텍스트
 * @readonly
 * @type {{[p: string]: string, [p: number]: string}}
 */
export const CATEGORY_EXHIBIT_TYPE_TEXT = {
  [CATEGORY_EXHIBIT_TYPE.INEXHIBIT]: 'N',
  [CATEGORY_EXHIBIT_TYPE.EXHIBIT]: 'Y',
};

/**
 * 카테고리 전시 타입 SELECT LIST
 * @readonly
 * @type {[{name: string, id: number}, {name: string, id: number}]}
 */
export const CATEGORY_EXHIBIT_TYPE_SELECT_LIST = [
  {
    id: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
    name: CATEGORY_EXHIBIT_TYPE_TEXT[CATEGORY_EXHIBIT_TYPE.INEXHIBIT],
  },
  {
    id: CATEGORY_EXHIBIT_TYPE.EXHIBIT,
    name: CATEGORY_EXHIBIT_TYPE_TEXT[CATEGORY_EXHIBIT_TYPE.EXHIBIT],
  },
];

/**
 * 카테고리 검색 키워드 타입
 * @readonly
 * @type {{CATEGORY_ID: number, ENTIRE: number, CATEGORY_NAME: number}}
 */
export const CATEGORY_SEARCH_KEYWORD_TYPE = {
  /**
   * 선택
   */
  NONE: 0,
  /**
   * 카테고리 id
   */
  ID: 1,
  /**
   * 카테고리 명
   */
  NAME: 2,
};

/**
 * 카테고리 검색 키워드 타입 텍스트
 * @readonly
 * @type {{[p: string]: string, [p: number]: string}}
 */
export const CATEGORY_SEARCH_KEYWORD_TYPE_TEXT = {
  [CATEGORY_SEARCH_KEYWORD_TYPE.NONE]: '선택',
  [CATEGORY_SEARCH_KEYWORD_TYPE.ID]: '카테고리 ID',
  [CATEGORY_SEARCH_KEYWORD_TYPE.NAME]: '카테고리 명',
};

/**
 * 카테고리 검색 키워드 타입 SELECT LIST
 * @readonly
 * @type {[{name: string, id: number}, {name: string, id: number}, {name: string, id: number}]}
 */
export const CATEGORY_SEARCH_KEYWORD_TYPE_SELECT_LIST = [
  {
    id: CATEGORY_SEARCH_KEYWORD_TYPE.NONE,
    name: CATEGORY_SEARCH_KEYWORD_TYPE_TEXT[CATEGORY_SEARCH_KEYWORD_TYPE.NONE],
  },
  {
    id: CATEGORY_SEARCH_KEYWORD_TYPE.ID,
    name: CATEGORY_SEARCH_KEYWORD_TYPE_TEXT[CATEGORY_SEARCH_KEYWORD_TYPE.ID],
  },
  {
    id: CATEGORY_SEARCH_KEYWORD_TYPE.NAME,
    name: CATEGORY_SEARCH_KEYWORD_TYPE_TEXT[CATEGORY_SEARCH_KEYWORD_TYPE.NAME],
  },
];

/**
 * 카테고리 검색 메인 타입
 * @readonly
 * @type {{ENTIRE: number, STATUS: number, KIND: number, EXHIBIT: number, EXPOSE: number, SORT: number}}
 */
export const CATEGORY_SEARCH_MAIN_TYPE = {
  /**
   * 전체
   */
  ENTIRE: 0,
  /**
   * 카테고리 종류
   */
  KIND: 1,
  /**
   * 카테고리 활성 여부
   */
  STATUS: 2,
  /**
   * 카테고리 전시 여부
   */
  EXHIBIT: 3,
  /**
   * 카테고리 노출 위치
   */
  EXPOSE: 4,
  /**
   * 카테고리 상품 정렬 순
   */
  SORT: 5,
};

/**
 * 카테고리 검색 메인 타입 텍스트
 * @readonly
 * @type {{[p: string]: string, [p: number]: string}}
 */
export const CATEGORY_SEARCH_MAIN_TYPE_TEXT = {
  [CATEGORY_SEARCH_MAIN_TYPE.ENTIRE]: '전체',
  [CATEGORY_SEARCH_MAIN_TYPE.KIND]: '카테고리 종류',
  [CATEGORY_SEARCH_MAIN_TYPE.STATUS]: '활성 여부',
  [CATEGORY_SEARCH_MAIN_TYPE.EXHIBIT]: '전시 여부',
  [CATEGORY_SEARCH_MAIN_TYPE.EXPOSE]: '노출 위치',
  [CATEGORY_SEARCH_MAIN_TYPE.SORT]: '상품 정렬순',
};

/**
 * 카테고리 검색 메인 타입 SELECT LIST
 * @readonly
 * @type {[{name: string, id: number}, {name: string, id: number}, {name: string, id: number}, {name: string, id: number}, {name: string, id: number}, null]}
 */
export const CATEGORY_SEARCH_MAIN_TYPE_SELECT_LIST = [
  {
    id: CATEGORY_SEARCH_MAIN_TYPE.ENTIRE,
    name: CATEGORY_SEARCH_MAIN_TYPE_TEXT[CATEGORY_SEARCH_MAIN_TYPE.ENTIRE],
  },
  {
    id: CATEGORY_SEARCH_MAIN_TYPE.KIND,
    name: CATEGORY_SEARCH_MAIN_TYPE_TEXT[CATEGORY_SEARCH_MAIN_TYPE.KIND],
  },
  {
    id: CATEGORY_SEARCH_MAIN_TYPE.STATUS,
    name: CATEGORY_SEARCH_MAIN_TYPE_TEXT[CATEGORY_SEARCH_MAIN_TYPE.STATUS],
  },
  {
    id: CATEGORY_SEARCH_MAIN_TYPE.EXHIBIT,
    name: CATEGORY_SEARCH_MAIN_TYPE_TEXT[CATEGORY_SEARCH_MAIN_TYPE.EXHIBIT],
  },
  {
    id: CATEGORY_SEARCH_MAIN_TYPE.EXPOSE,
    name: CATEGORY_SEARCH_MAIN_TYPE_TEXT[CATEGORY_SEARCH_MAIN_TYPE.EXPOSE],
  },
  {
    id: CATEGORY_SEARCH_MAIN_TYPE.SORT,
    name: CATEGORY_SEARCH_MAIN_TYPE_TEXT[CATEGORY_SEARCH_MAIN_TYPE.SORT],
  },
];

export const GENERAL_CATEGORY_NAME_MAX_LENGTH = 11;
export const EMPHASIS_CATEGORY_NAME_MAX_LENGTH = 8;
export const SUB_CATEGORY_NAME_MAX_LENGTH = 12;

/**
 * 카테고리 서브 텍스트 최대 길이
 * @readonly
 * @type {number}
 */
export const CATEGORY_SUB_TEXT_MAX_LENGTH = 20;

/**
 * 카테고리 생성 사유 텍스트 최대 길이
 * @readonly
 * @type {number}
 */
export const CATEGORY_MEMO_TEXT_MAX_LENGTH = 1000;

export const GENERAL_CATEGORY_EXHIBIT_MAX_LENGTH = 50;
export const EMPHASIS_CATEGORY_EXHIBIT_MAX_LENGTH = 20;

export const BASE_CATEGORY_ID = {
  EARRING: 1,
  NECKLACE: 2,
  RING: 3,
  BRACELET: 4,
  ANKLET: 7,
  EARCUFF: 8,
};
export const BASE_CATEGORY_ID_ARRAY = [
  BASE_CATEGORY_ID.EARRING,
  BASE_CATEGORY_ID.NECKLACE,
  BASE_CATEGORY_ID.RING,
  BASE_CATEGORY_ID.BRACELET,
  BASE_CATEGORY_ID.ANKLET,
  BASE_CATEGORY_ID.EARCUFF,
];

/**
 *  S3 에 저장 될 카테고리 배너 이미지 너비
 */
export const CATEGORY_BANNER_IMG_WIDTH = 216;

/**
 *  S3 에 저장 될 카테고리 배너 이미지 높이
 */
export const CATEGORY_BANNER_IMG_HEIGHT = 216;
